import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getIdTokenResult, onAuthStateChanged } from 'firebase/auth';
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async user => {
      setCurrentUser(user);
      setIsAdmin(false);

      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const tokenResult = await getIdTokenResult(user, true);
        const adminClaim = tokenResult?.claims?.isAdmin === true;
        setIsAdmin(adminClaim);

        // Simpan profil user sederhana (untuk kebutuhan "users" collection).
        // Role/akses tetap aman dari custom-claim, bukan dari data Firestore.
        await setDoc(
          doc(db, 'users', user.uid),
          {
            uid: user.uid,
            email: user.email ?? null,
            displayName: user.displayName ?? null,
            photoURL: user.photoURL ?? null,
            lastLoginAt: serverTimestamp(),
          },
          { merge: true }
        );
      } catch (err) {
        // Jangan block UI kalau gagal menulis profil (misal rules belum dipublish).
        console.error('AuthContext error:', err);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const value = useMemo(() => ({ currentUser, isAdmin }), [currentUser, isAdmin]);

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
} 
